import * as React from 'react';

export function ChevronDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4703 7.28033C16.7632 6.98744 16.7632 6.51256 16.4703 6.21967C16.1774 5.92678 15.7025 5.92678 15.4096 6.21967L9.84497 11.7843L4.28035 6.21969C3.98745 5.92679 3.51258 5.92679 3.21969 6.21969C2.92679 6.51258 2.92679 6.98745 3.21969 7.28035L9.30958 13.3702C9.45763 13.5183 9.65218 13.5915 9.84621 13.5899C10.0394 13.5909 10.233 13.5176 10.3804 13.3702L16.4703 7.28033Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChevronDown;
